/** Geoserver 起動状態 */
export const GEO_SERVER_STATUS = {
  RUNNING: 'RUNNING',
  PROVISIONING: 'PROVISIONING',
  FAILED: 'FAILED'
} as const

/** Geoserver 取得するレイヤータイプ */
export const GET_LAYER_TYPE = {
  /** 航空写真 */
  AERIAL: 'aerial',
  /** オルソ画像 */
  ORTHO: 'ortho',
  /** 点群 */
  POINT: 'point',
  /** ヒートマップ */
  GRID: 'grid'
}

/** Geoserver 起動状態 ラベル */
export const GEO_SERVER_STATUS_LABEL = {
  [GEO_SERVER_STATUS.RUNNING]: { label: '正常' },
  [GEO_SERVER_STATUS.PROVISIONING]: { label: '起動準備中' },
  [GEO_SERVER_STATUS.FAILED]: { label: '失敗' }
}
